export enum FeatureNames {
  KEYWORD_REVIEW_CROSS_ANALYSIS = "keyword_review_cross_analysis",
  KEYWORD_REVIEW_CROSS_ANALYSIS_V2 = "keyword_review_cross_analysis_v2"
}
